import React, { useState } from "react";
import { View } from "react-native";
import { WebView } from "react-native-webview";
import { PageBottom } from "../accessories/accessories";
import { web } from "../accessories/Platform";

const PlaidAuthenticator = (props) => {
  const { handleLoad, handleEvent, handleSuccess } = props;
  const handleWebViewMessage = (event) => {
    console.log("event", event);
    const data = JSON.parse(event.nativeEvent.data);
    if (data.type === "success") {
      handleSuccess(data.token, data.metadata);
    } else if (data.type === "event") {
      handleEvent(data.event);
    }
  };
  //   const source = false
  //     ? require("./plaid.html")
  //     : {
  //         html: `<!DOCTYPE html>
  // <html lang="en">
  // <head>
  // <meta charset="UTF-8">
  // <meta name="viewport" content="width=device-width, initial-scale=1.0">
  // <script src="https://cdn.plaid.com/link/v2/stable/link-initialize.js"></script>
  // </head>
  // <body>
  // <div id="plaid-container"></div>
  // <script>

  // const plaidLink = Plaid.create({
  // env: "production",
  // clientName: 'Direct Mortgage.',
  // product: ['auth'],
  // key: "48d65e959b8b7d6d88803b51a3f168",
  // onSuccess: function(token, metadata) {
  //   window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'success', token, metadata }));
  // },
  // onEvent: function(event) {
  //   window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'event', event }));
  // }
  // });

  // plaidLink.open();
  // </script>
  // </body>
  // </html>
  // `,
  //       };
  const source = {
    uri: "https://www.solutioncenter.biz/GoDirectplaid/plaid.html",
  };
  return (
    <View style={[{ flex: 1 }]}>
      <WebView
        originWhitelist={["*"]}
        source={source}
        onMessage={handleWebViewMessage}
        javaScriptEnabled={true}
        domStorageEnabled={true}
      />
      {/* {!web && <PageBottom />} */}
    </View>
  );
};

export default PlaidAuthenticator;
